import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import React, {Component} from "react";
import {AuthService} from "../services/auth-service";
import {matchPath, withRouter} from "react-router-dom";

class DefaultLayout extends Component {

    constructor(props)
    {
        super(props);

        this.authService = new AuthService();

        if (this.authService.hasUserDataExpired()) {
            this.clearAuthState();
        }

       
    }

    clearAuthState = () =>  {
       
        this.authService.clearUserCache();
        this.props.history.push("/");

        if(matchPath(this.props.location.pathname) === "/")
        { window.location.reload(); }
    };

    render() {
        return (
            <React.Fragment>
                <header id="site-header">
                    <Header />
                </header>
                <div className="content">
                    {this.props.children}
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}

export default withRouter(DefaultLayout)
